/**
 * Registers the PWA service worker (built by vite-plugin-pwa to `/ws/sw.js`).
 *
 * Scope follows the base path: `/` on an institute's own host, `/<slug>/` on
 * the TutorLoop path host, so each institute gets its own registration. The
 * worker only precaches the build's static files (the same for everyone) and
 * has no runtime caching of API or media, so one institute's data can never
 * be served to another. Precache storage is keyed by scope as well.
 * The server sends `Service-Worker-Allowed: /` for `/ws/sw.js` (deploy/nginx.conf).
 */

import { basePath, publicUrl } from "./tenant/basePath";

export function registerServiceWorker(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register(publicUrl("sw.js"), { scope: `${basePath}/` }).catch(() => undefined);
  });
}
